// src/encounter/care-plan-tab/care-plan-labels.ts
// The Care plan tab's words: lane names in the demo's order, the board's status labels and its 12 weeks.
import type { CarePlanActivityView, CarePlanLane } from '../lib/care-plan-view';

/** The demo's lane names, in its order. */
export const CARE_PLAN_LANE_LABEL: Record<CarePlanLane, string> = {
  'physician-orders': 'Physician orders',
  nutrition: 'Nutrition',
  exercise: 'Exercise',
  coaching: 'Coaching',
  supplements: 'Supplements',
  physiotherapy: 'Physiotherapy',
};
export const PLAN_WEEKS = 12;

/** The board's word for a status. "AI draft" is a label only (Andrew 4 Nov): no engine call. */
export const ACTIVITY_STATUS_LABEL: Record<CarePlanActivityView['status'], string> = {
  'ai-draft': 'AI draft',
  draft: 'Draft',
  accepted: 'Accepted · unsigned',
  signed: 'Signed',
};

/** The weeks an item is drawn across, clamped to the board; `past` = it runs after W12 (said in words, never hidden). */
export function boardWeeks(weekFrom: number, weekTo: number): { from: number; to: number; past: boolean } {
  const from = Math.min(Math.max(1, weekFrom), PLAN_WEEKS);
  const to = Math.min(Math.max(from, weekTo), PLAN_WEEKS);
  return { from, to, past: weekTo > PLAN_WEEKS };
}
